var toggle = document.querySelector('#hamburger');
if (toggle) {
    toggle.addEventListener('click', function (e) {
        // toggle.classList.toggle('open');
        toggle.dataset.state = toggle.dataset.state === 'open' ? "closed" : "open";
    });
}

const myOffcanvas = document.getElementById("offcanvasWithBackdrop");
if (myOffcanvas) {
	myOffcanvas.addEventListener("hidden.bs.offcanvas", (event) => {
        toggle.dataset.state = toggle.dataset.state === "closed";
	});
}
// var animate = setInterval(() => {
//     toggle.checked = !toggle.checked
// }, 3000)

// document.querySelector('body').addEventListener('click', () => {
//     clearInterval(animate);

// });